/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	const __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter/value functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			if(Array.isArray(definition)) {
/******/ 				var i = 0;
/******/ 				while(i < definition.length) {
/******/ 					var key = definition[i++];
/******/ 					var binding = definition[i++];
/******/ 					if(!__webpack_require__.o(exports, key)) {
/******/ 						if(binding === 0) {
/******/ 							Object.defineProperty(exports, key, { enumerable: true, value: definition[i++] });
/******/ 						} else {
/******/ 							Object.defineProperty(exports, key, { enumerable: true, get: binding });
/******/ 						}
/******/ 					} else if(binding === 0) { i++; }
/******/ 				}
/******/ 			} else {
/******/ 				for(var key in definition) {
/******/ 					if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 						Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
let __webpack_exports__ = {};
/*!***********************************!*\
  !*** ./src/js/zone3-accordion.js ***!
  \***********************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   initZone3Accordion: () => (/* binding */ initZone3Accordion)
/* harmony export */ });
function getAccordionPanel(item) {
  return item.querySelector('[data-accordion-item-content]');
}
function openAccordionItem(item, trigger, panel) {
  item.classList.remove('is-collapsed');
  trigger.setAttribute('aria-expanded', 'true');
  panel.hidden = false;
  panel.style.overflow = 'hidden';
  panel.style.height = "".concat(panel.scrollHeight, "px");
  var _onEnd = function onEnd(event) {
    if (event.target !== panel || event.propertyName !== 'height') return;
    panel.style.height = '';
    panel.style.overflow = '';
    panel.removeEventListener('transitionend', _onEnd);
  };
  panel.addEventListener('transitionend', _onEnd);
}
function closeAccordionItem(item, trigger, panel) {
  var animate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  item.classList.add('is-collapsed');
  trigger.setAttribute('aria-expanded', 'false');
  if (!animate) {
    panel.style.overflow = 'hidden';
    panel.style.height = '0px';
    panel.hidden = true;
    return;
  }
  panel.style.overflow = 'hidden';
  panel.style.height = "".concat(panel.scrollHeight, "px");
  panel.getBoundingClientRect();
  requestAnimationFrame(function () {
    panel.style.height = '0px';
  });
  var _onEnd2 = function onEnd(event) {
    if (event.target !== panel || event.propertyName !== 'height') return;
    panel.hidden = true;
    panel.removeEventListener('transitionend', _onEnd2);
  };
  panel.addEventListener('transitionend', _onEnd2);
}
function toggleAccordionItem(item, trigger, panel) {
  if (item.classList.contains('is-collapsed')) {
    openAccordionItem(item, trigger, panel);
  } else {
    closeAccordionItem(item, trigger, panel);
  }
}
function initAccordionRoot(root) {
  if (root.dataset.accordionInitialized === 'true') return;
  root.dataset.accordionInitialized = 'true';
  root.querySelectorAll('[data-accordion-item]').forEach(function (item) {
    var trigger = item.querySelector('[data-accordion-item-title]');
    var panel = getAccordionPanel(item);
    if (!trigger || !panel) return;
    closeAccordionItem(item, trigger, panel, false);
  });
}
function initZone3Accordion() {
  document.querySelectorAll('.zone3__accordion').forEach(initAccordionRoot);
  if (document.documentElement.dataset.zone3AccordionBound === 'true') {
    return Promise.resolve(true);
  }
  document.documentElement.dataset.zone3AccordionBound = 'true';
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-accordion-item-title]');
    if (!trigger) return;
    var item = trigger.closest('[data-accordion-item]');
    if (!(item !== null && item !== void 0 && item.closest('.zone3__accordion'))) return;
    var panel = getAccordionPanel(item);
    if (!panel) return;
    toggleAccordionItem(item, trigger, panel);
  });
  return Promise.resolve(true);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initZone3Accordion);
} else {
  initZone3Accordion();
}
/******/ })()
;
//# sourceMappingURL=zone3-accordion.js.map